import React, { useMemo, useState } from "react";
import { Pagination as PaginationType } from "@sscs/types";
import { DataTable, DataTableColumn, Table } from "@sscs/ui";
import { convertToReadable, getPageItems, getQueryStatus } from "@sscs/utils";
import { useGetGroupUsageDetailsQuery } from "Services";

const initPagination: PaginationType = {
  currentPage: 1,
  itemsPerPage: 10,
};

const COLUMNS: DataTableColumn[] = [
  { id: "name", label: "Project name", width: "100%", minWidth: "130px" },
  { id: "versions", label: "Versions", width: "300px" },
  { id: "usage", label: "Usage (GB)", width: "300px" },
];

type ProjectsUsageProps = {
  groupId: string;
};

const ProjectsUsage = ({ groupId }: ProjectsUsageProps): React.JSX.Element => {
  const [pagination, setPagination] = useState(initPagination);
  const { data, isLoading, isFetching, isError, error } =
    useGetGroupUsageDetailsQuery({
      groupId: groupId,
    });
  const projectsUsage = useMemo(() => {
    if (data)
      return getPageItems(
        data.project_usages,
        pagination.currentPage,
        pagination.itemsPerPage,
      );
    else return [];
  }, [data, pagination]);

  return (
    <DataTable
      chrome="card"
      title="Usage by project"
      columns={COLUMNS}
      empty={{ subject: "projects" }}
      status={getQueryStatus({
        data,
        isLoading,
        isFetching,
        isError,
        error,
      })}
      pagination={{
        itemCount: data?.project_usages.length ?? 0,
        pagination,
        onChange: setPagination,
      }}
    >
      {projectsUsage.map((project) => (
        <Table.Row key={project.project_id} hover>
          <Table.Cell>{project.project_name}</Table.Cell>
          <Table.Cell>{project.version_count}</Table.Cell>
          <Table.Cell>
            {convertToReadable(project.project_usage_bytes)}
          </Table.Cell>
        </Table.Row>
      ))}
    </DataTable>
  );
};

export default ProjectsUsage;
